
namespace SorAraBul.Administration {
    export class CompaniesColumns {
        static columnsKey = 'Administration.Companies';
    }
}